module.exports = __webpack_public_path__ + "f8566f419e336f22a492d7bde9b1551d.png";